import React from 'react';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import partnership_img from '../../assets/partnership.webp';
import { UserContext } from '../../context/UserContext';
import { default_authenticated_home_url } from '../../components/routing/Routes';
import { BodyText, Title } from '../../components/shared/typography/PrimaryTypography';
import PrimaryButton from '../../components/shared/button/PrimaryButton';

const ThankYouPage = () => {
  const { authenticated } = React.useContext(UserContext);
  return (
    <Box
      sx={{
        display: 'flex',
        paddingY: 4,
        flexDirection: 'column',
        margin: 'auto',
        alignItems: 'center',
        gap: 3
      }}
      width={{ xs: '100%', md: '60%' }}
    >
      <Title>Thank You</Title>
      <img src={partnership_img} width={350} />
      <BodyText>
        Your Contact Request was successful! An Energy Partners representative will be in touch
        shortly via the contact details you provided. In the meantime, explore the links above to
        level up your ESG knowledge.
      </BodyText>

      <Box sx={{ paddingTop: '25px' }}>
        <Link to={authenticated ? default_authenticated_home_url : '/'}>
          <PrimaryButton sx={{ fontSize: 16, minWidth: 150, minHeight: 60 }}>
            Back to Home
          </PrimaryButton>
        </Link>
      </Box>
    </Box>
  );
};

export default ThankYouPage;
